import { Button, Select } from "@appkit4/react-components";
import { useEffect, useState } from "react";
import toast from "../../../components/DismissibleToast";
import sqldatabaseService from "../../../services/sqldatabase/sqldatabase.service";
import "../home.scss";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const ReinstateResponseModal = ({
  groupList,
  fetchGroups,
  resetForm,
  setResetForm,
}) => {
  const [selectedGroupName, setSelectedGroupName] = useState();
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    if (resetForm) {
      setSelectedGroupName("");
      setSelectedGroupId("");
      setResetForm(false);
    }
  }, [resetForm]);

  const processGroup = () => {
    if (selectedGroupId) {
      setButtonDisabled(true);
      const promise = sqldatabaseService
        .postReinstateNonSubmittedResponse(selectedGroupId)
        .then((response) => {
          if (response.status !== 200) {
            // Return an object that includes the error message instead of throwing an error
            return {
              error: true,
              message: `Error: Status ${response.status} - ${response.err}`,
            };
          }
          return response;
        });

      return toast
        .promise(promise, {
          loading: `Reinstating NonSubmitted Response for group: ${selectedGroupName}`,
          success: (response) => {
            // Check if there was an error
            if (response.error) {
              throw new Error(response.message);
            } else {
              fetchGroups();
            }
            setSelectedGroupName("");
            setSelectedGroupId("");
            return `Reinstated NonSubmitted Response for group: ${selectedGroupName}`;
          },
          error: (error) => {
            console.log("error breaking:", error.message);
            return `Failed to reinstate response. ${error}`;
          },
        })
        .then(() => {
          setButtonDisabled(false);
        });
    }
  };

  return (
    <div className="flex-space-between">
      <Select
        placeholder={"Select Group"}
        value={selectedGroupName}
        style={{ width: "35rem" }}
        searchable
        data={getNamesFromList(groupList)}
        dropdownRenderMode={"portal"}
        onSelect={(groupName) => {
          setSelectedGroupName(groupName);
          setSelectedGroupId(getIdByName(groupName, groupList));
        }}
      ></Select>
      <Button
        disabled={!selectedGroupName || buttonDisabled}
        onClick={() => processGroup()}
      >
        Reinstate Latest Non-Submitted Response
      </Button>
    </div>
  );
};

export default ReinstateResponseModal;
